/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Button, Input, Label, Modal, InputSelect, Pagination, CustomLoading, Breadcrumb, SaveIcon, CustonModal } from "../../../Components";

/* 🔗 SERVICE */
import { EquipamentServices } from "../../../Services/equipamentosServices";

/* 🧠 REDUX */
import { store } from "../../../Redux/Store";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { changeLoationtypes, changeModal } from "../../../Redux/Actions";

/* 📁 ASSETS*/
import { Lupa, Atualizar } from "../../../Assets/icons";

/* 🎨 STYLES */
import { Container, CountContainer, LineTitle, TitleText, LineList, ListText, ListButton, PageTitle, ContainerList, HeaderContainer, 
    InputContainer, FilterInput, ContainerHead, ContainerRow, ButtonsContainer, ContainerColumn, ImageIcon, RowContainer, ContentHeader } from "./styles";

/* 🔧 UTILS */
import { isValidField } from "../../../util/validate";

import { useNavigate } from "react-router";

const ListEquipaments = () => {
    // const navigate = useNavigate();
    const { t } = useTranslation();

    document.title = t("administrative.sub-items.equipments.list.document-title");

    const navigationFlow =  [
        { text: 'administrative', page: '/adm/equipamentos' },
        { text: 'equipments', page: '/adm/equipamentos' },
    ]
    
    const [equipamentos, setEquipamentos] = useState([]);
    const [equipamentType, setEquipamentType] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [activeModal, setActiveModal] = useState("");
    
    const Services = useRef(new EquipamentServices());
    const alocacao_typeField = useRef();
    const alocacaoField = useRef();
    const ProcessField = useRef();
    const MacField = useRef();
    const NameField = useRef();
    const EquipamentTypeField = useRef();
    const ETAField = useRef();
    const StateField = useRef();
    const CityField = useRef();
    const ResolutionField = useRef();
    const pocoConfig = useRef({});
    
    const LatField = useRef();
    const LongField = useRef();
    
    const alocacaoValue = useRef();
    const ProcessValue = useRef();
    const MacValue = useRef();
    const NameValue = useRef();
    const EquipamentTypeValue = useRef();
    const ETAValue = useRef();
    const CityValue = useRef();
    const ResolutionValue = useRef();
    const searchValue = useRef();
    
    const LatValue = useRef();
    const LongValue = useRef();
    
    const user = useSelector(state => state.userReducer);
    const Locations = useSelector(state => state.UserCurdReducer.Locations);
    const LocationTypes = useSelector(state => state.UserCurdReducer.LocationTypes);
    const [equipmentsTypes, setEquipmentsTypes] = useState([]);

    let active = useSelector(state => state.ModalReducer.name);

    const getEquipaments = async() => {
        setIsLoading(true);
        let currentEquipaments = await Services.current.getAllEquipaments('');
        setEquipamentos(currentEquipaments);
        setIsLoading(false);
    }

    // Busca alocações do usuário
    const getLocations = async() => {
        try {
            let AllLocations = await Services.current.getLocations();

            let Types = Object.keys(AllLocations).map(type => {
                return{
                    id: type,
                    name: type
                }
            })
            store.dispatch(changeLoationtypes(Types));
        } catch (error) {
            
        }
    }

    const getStates = async() =>{
        try {
            let States = await Services.current.getStates();
            setStates(States);
        } catch (error) {
            
        }
    }

    const getEquipmentsTypes = async() => {
        try {
            let Types = await Services.current.getEquipamentsTypes();
            setEquipmentsTypes(Types);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getEquipaments();
        getEquipmentsTypes();
        getLocations();
        getStates();
    }, []);

    const Aplyfilter = async() => {
        setIsLoading(true);
        let currentEquipaments = await Services.current.getAllEquipaments(searchValue.current);
        setEquipamentos(currentEquipaments);
        setIsLoading(false);
    }

    // Salva as edições do usuário
    const Save = async() => {
        if(isValidField(NameValue.current) && isValidField(EquipamentTypeValue.current) &&
        isValidField(alocacaoValue.current) && isValidField(CityValue.current)){
            let form = new FormData();
            
            if(NameValue.current){form.append('name', NameValue.current)}
            if(EquipamentTypeValue.current){form.append('id_type', EquipamentTypeValue.current)}
            if(alocacaoValue.current){form.append('id_allocation', alocacaoValue.current)}
            if(CityValue.current){form.append('city_code', CityValue.current)}
            if(LatValue.current){form.append('latitude', LatValue.current)}
            if(LongValue.current){form.append('longitude', LongValue.current)}

            if(EquipamentTypeValue.current === '1f4d0674-1e7a-48c5-925f-87e2d99bcda5'){
                // Número de serie do processador (Poço)
                if(ProcessValue.current){form.append('processor_id', ProcessValue.current)}
                
                // Configurações do poço
                if(pocoConfig.current.AL1){form.append('hasAL1', pocoConfig.current.AL1)}
                if(pocoConfig.current.AL2){form.append('hasAL2', pocoConfig.current.AL2)}
                if(pocoConfig.current.AL3){form.append('hasAL3', pocoConfig.current.AL3)}
                if(pocoConfig.current.AL4){form.append('hasAL4', pocoConfig.current.AL4)}
                if(pocoConfig.current.AL5){form.append('hasAL5', pocoConfig.current.AL5)}
                if(pocoConfig.current.macro){form.append('hasMacro', pocoConfig.current.macro)}
                if(pocoConfig.current.acido){form.append('hasAcido', pocoConfig.current.acido)}
                if(pocoConfig.current.hipo){form.append('hasHipo', pocoConfig.current.hipo)}
                if(pocoConfig.current.orto){form.append('hasOrto', pocoConfig.current.orto)}
                if(pocoConfig.current.ph){form.append('hasPh', pocoConfig.current.ph)}
                if(pocoConfig.current.pressure){form.append('hasPressure', pocoConfig.current.pressure)}
                if(pocoConfig.current.level){form.append('hasLevel', pocoConfig.current.level)}
            }else if(equipamentType === 'd0effc9e-4b90-4212-b800-4fb17cd5f67a' || equipamentType === 'de4a6821-eb4c-492b-96c1-7ab704f053f6' ||
                equipamentType === '782e9b76-5a92-4ad4-ba2a-5a6f84cb9ae1' || equipamentType === 'ce27f1ab-2a42-45a2-a5c1-2a4e498b90d6'){
                // Mac address do equipamento (NBIOT)
                if(MacValue.current){form.append('mac_address', MacValue.current)}

                if(ResolutionValue.current){form.append('resolution', ResolutionValue.current)}
            }else if(equipamentType === '0a22e8ed-42c1-496c-8d0a-82a4e05371c1'){
                // Modulo
                if(ETAValue.current){form.append('eta', ETAValue.current)}
            }else if(equipamentType === '52e63208-66ed-4a57-b41f-6f93b1b12f76'){
                // LORA
                if(ProcessValue.current){form.append('processor_id', ProcessValue.current)}
            }


            // if(LongValue.current){form.append('longitude', LongValue.current)}
            // if(LatValue.current){form.append('latitude', LatValue.current)}
            // if(AddressValue.current){form.append('group_id', AddressValue.current)}

            Services.current.Saveequipament(form);
            store.dispatch(changeModal(''));
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    const changepage = async(page) => {
        setIsLoading(true);
        let currentEquipaments = await Services.current.getAllEquipaments(searchValue.current, page);
        setEquipamentos(currentEquipaments);
        setIsLoading(false);
    }

    const ChangeCities = async(state) => {
        try {
            let Cities = await Services.current.getCities(state);
            setCities(Cities);
        } catch (error) {
            
        }
    }

    const navigate = useNavigate();

    return(
        <>
            <Container>
                <Breadcrumb flow={navigationFlow}/>
                <PageTitle>
                    {t("administrative.sub-items.equipments.list.page-title")}
                </PageTitle>

                <HeaderContainer>
                    <ContentHeader>
                        <InputContainer>
                            <img src={Lupa} alt={t("inputs.search-equipment.alt")}></img>
                            <FilterInput
                                // onBlur={()=>Aplyfilter()}
                                onKeyDown={(e) => e.key === 'Enter' && Aplyfilter()}
                                onChange={(e) => searchValue.current = e.target.value}
                                placeholder={t("inputs.search-equipment.placeholder")}
                            />
                        </InputContainer>

                        <Button width={'fit-content'} text={t("buttons.apply")} color={'green'} onClick={() => Aplyfilter()}></Button>
                    </ContentHeader>

                    <ContentHeader>
                        <Button text={t("buttons.settings")} href='/adm/equipamentos/equip-cruds'  onClick = {() => {navigate('/adm/equipamentos/equip-cruds')}}/>
                        {user?.user?.can?.includes('equipment.create') ?
                            <div className="admin-buttons">
                                <Button onClick={() => store.dispatch(changeModal('newequipament'))} width={'fit-content'} color={'green'} icon={''} text={t("buttons.register-equipment")} />
                                    {user?.user?.can?.includes('card.autoupdate') && 
                                    (user?.user?.id === "182fbfd6-86ab-4fa2-b588-c12825c64361" || user?.user?.id === "2123e214-6dde-4dc0-9911-41b17ff4b067") &&
                                    <Button text={t("buttons.refresh-data")} icon={<ImageIcon src={Atualizar}/>} onClick={() => setActiveModal('update-jsons')}/>}
                            </div>
                        : <></>}
                    </ContentHeader>
                </HeaderContainer>
                
                <ContainerHead>
                    <CountContainer>
                        {t("administrative.sub-items.list-total") + " " + equipamentos?.meta?.total + " " + t("administrative.sub-items.equipments.list.equipments")} 
                    </CountContainer>
                </ContainerHead>

                <ContainerList>
                    <LineTitle>
                        {/* <TitleText>Id</TitleText> */}
                        <TitleText>{t("header-table.name")}</TitleText>
                        <TitleText>{t("header-table.type")}</TitleText>
                        <TitleText>{t("header-table.allocation")}</TitleText>
                        <TitleText $align={'center'} width={'100px'}>{t("header-table.actions")}</TitleText>
                    </LineTitle>
                    {isLoading?
                        <CustomLoading width={'150px'} height={'150px'}/>
                    :
                        equipamentos?.data?.map((item) => (
                            <LineList key={item.id} href={user?.user?.can?.includes('equipment.view') ? `/adm/equipamentos/${item.id}` : undefined}>
                                {/* <ListText>{item.id}</ListText> */}
                                <ListText>{item.name}</ListText>
                                <ListText>{item.type.name}</ListText>
                                <ListText>{item.allocation.name}</ListText>
                                <ListText $align={'center'} width={'100px'}>
                                    <ListButton disabled={true}>...</ListButton>
                                </ListText>
                            </LineList>
                        ))
                    }
                </ContainerList>

                {isLoading?
                    <></>
                :<Pagination last_page={equipamentos?.meta?.last_page} currentpage={equipamentos?.meta?.current_page} changepage={changepage}/>}

            </Container>
            
            <Modal title={t("modal.register-equipment.title")} name={'newequipament'} width={'70%'} height={'90%'} >
                {active === 'newequipament' ?
                    <>
                        <ContainerRow onSubmit={(e) => e.preventDefault()}>
                            <ContainerColumn>
                                <Label text={t("inputs.name.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='name' 
                                    name='name' 
                                    type="text" 
                                    placeholder={t("inputs.name.placeholder")}
                                    innerRef={NameField}
                                    invalidMessage={t("inputs.name.invalid-message")}
                                    validationFunction = {(text) => isValidField(text)}
                                    onchange={(text) => NameValue.current = text}> 
                                </Input>

                                <Label text={t("inputs.equipment-type.label")} aling="flex-start"/>
                                <InputSelect
                                    name={'equipament'}
                                    id={'equipament'}
                                    placeholder={t("inputs.equipment-type.placeholder")}
                                    invalidMessage={t("inputs.equipment-type.invalid-message")}
                                    options={equipmentsTypes}
                                    innerRef={EquipamentTypeField}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => {
                                        setEquipamentType(value);
                                        EquipamentTypeValue.current = value;
                                    }}>
                                </InputSelect>

                                {(equipamentType === '1f4d0674-1e7a-48c5-925f-87e2d99bcda5' || equipamentType === '52e63208-66ed-4a57-b41f-6f93b1b12f76') &&
                                    <>
                                        <Label text={t("inputs.processor.label")} aling="flex-start"/>
                                        <Input 
                                            aling="flex-start"
                                            id='processador' 
                                            name='processador' 
                                            type="text" 
                                            placeholder={t("inputs.processor.placeholder")}
                                            innerRef={ProcessField}
                                            invalidMessage="Processador inválido"
                                            validationFunction={(text) => isValidField(text)}
                                            onchange={(text) => ProcessValue.current = text}> 
                                        </Input>
                                    </>
                                }

                                {(equipamentType === 'd0effc9e-4b90-4212-b800-4fb17cd5f67a' || equipamentType === 'de4a6821-eb4c-492b-96c1-7ab704f053f6' ||
                                    equipamentType === '782e9b76-5a92-4ad4-ba2a-5a6f84cb9ae1' || equipamentType === 'ce27f1ab-2a42-45a2-a5c1-2a4e498b90d6') &&
                                    <>
                                        <Label text={t("inputs.mac-address.label")} aling="flex-start"/>
                                        <Input 
                                            aling="flex-start"
                                            id='macAddress' 
                                            name='macAddress' 
                                            type="text" 
                                            placeholder={t("inputs.mac-address.placeholder")}
                                            innerRef={MacField}
                                            invalidMessage={t("inputs.mac-address.invalid-message")}
                                            validationFunction={(text) => isValidField(text)}
                                            onchange={(text) => MacValue.current = text}> 
                                        </Input>
                                    </>
                                }
                            </ContainerColumn>
                            
                            <ContainerColumn>
                                <Label text={t("inputs.allocation-type.label")} aling="flex-start"/>
                                <InputSelect
                                    key={'alocacao_type'}
                                    name={'alocacao_type'}
                                    id={'alocacao_type'}
                                    placeholder={t("inputs.allocation-type.placeholder")}
                                    invalidMessage={t("inputs.allocation-type.invalid-message")}
                                    options={LocationTypes}
                                    innerRef={alocacao_typeField}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => Services.current.ChangeLocationType(value, alocacaoField.current)}>
                                </InputSelect>

                                <Label text={t("inputs.allocation-local.label")} aling="flex-start"/>
                                <InputSelect
                                    key={'alocacao'}
                                    name={'alocacao'}
                                    id={'alocacao'}
                                    placeholder={t("inputs.allocation-local.placeholder")}
                                    invalidMessage={t("inputs.allocation-local.invalid-message")}
                                    options={Locations}
                                    innerRef={alocacaoField}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => alocacaoValue.current = value}>
                                </InputSelect>

                                <Label text={t("inputs.latitude.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='latitude' 
                                    name='latitude' 
                                    type="text" 
                                    placeholder={t("inputs.latitude.placeholder")}
                                    innerRef={LatField}
                                    invalidMessage={t("inputs.latitude.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => LatValue.current = text}> 
                                </Input>

                                {equipamentType === '0a22e8ed-42c1-496c-8d0a-82a4e05371c1' ?
                                    <>
                                        <Label text={t("inputs.eta.label")} aling="flex-start"/>
                                        <InputSelect
                                            name={'eta'}
                                            id={'eta'}
                                            placeholder={t("inputs.eta.placeholder")}
                                            invalidMessage={t("inputs.eta.invalid-message")}
                                            options={[]}
                                            innerRef={ETAField}
                                            validationFunction={(value) => isValidField(value)}
                                            onchange={(value) => ETAValue.current = value}>
                                        </InputSelect>
                                    </>
                                :<></>}

                                {/* {equipamentType === '1f4d0674-1e7a-48c5-925f-87e2d99bcda5'?
                                <>
                                    <InputCheckbox text={'Analisador 1'} onChange={(value)=> {pocoConfig.current.AL1 = value; return true}}/>
                                    <InputCheckbox text={'Analisador 2'} onChange={(value)=> {pocoConfig.current.AL2 = value; return true}}/>
                                    <InputCheckbox text={'Analisador 3'} onChange={(value)=> {pocoConfig.current.AL3 = value; return true}}/>
                                    <InputCheckbox text={'Analisador 4'} onChange={(value)=> {pocoConfig.current.AL4 = value; return true}}/>
                                    <InputCheckbox text={'Analisador 5'} onChange={(value)=> {pocoConfig.current.AL5 = value; return true}}/>
                                    <InputCheckbox text={'Macro'} onChange={(value)=> {pocoConfig.current.macro = value; return true}}/>
                                </>
                                :null} */}
                            </ContainerColumn>

                            <ContainerColumn>
                                <Label text={t("inputs.state.label")} aling="flex-start"/>
                                <InputSelect
                                    name={'state'}
                                    id={'state'}
                                    placeholder={t("inputs.state.placeholder")}
                                    invalidMessage={t("inputs.state.invalid-message")}
                                    options={states}
                                    innerRef={StateField}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => ChangeCities(value)}>
                                </InputSelect>

                                <Label text={t("inputs.city.label")} aling="flex-start"/>
                                <InputSelect
                                    name={'city'}
                                    id={'city'}
                                    placeholder={t("inputs.city.placeholder")}
                                    invalidMessage={t("inputs.city.invalid-message")}
                                    options={cities}
                                    innerRef={CityField}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => CityValue.current = value}>
                                </InputSelect>

                                <Label text={t("inputs.longitude.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='name' 
                                    name='name' 
                                    type="text" 
                                    placeholder={t("inputs.longitude.placeholder")}
                                    innerRef={LongField}
                                    invalidMessage={t("inputs.longitude.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => LongValue.current = text}> 
                                </Input>

                                {/* {equipamentType === '1f4d0674-1e7a-48c5-925f-87e2d99bcda5' &&
                                <>
                                    <InputCheckbox text={'Dosagem Hipo'} onChange={(value)=> {pocoConfig.current.hipo = value; return true}}/>
                                    <InputCheckbox text={'Dosagem Acido'} onChange={(value)=> {pocoConfig.current.acido = value; return true}}/>
                                    <InputCheckbox text={'Dosagem Orto'} onChange={(value)=> {pocoConfig.current.orto = value; return true}}/>
            
                                    <InputCheckbox text={'pH'} onChange={(value)=> {pocoConfig.current.ph = value; return true}}/>
                                    <InputCheckbox text={'Pressão'} onChange={(value)=> {pocoConfig.current.pressure = value; return true}}/>
                                    <InputCheckbox text={'Nivel'} onChange={(value)=> {pocoConfig.current.level = value; return true}}/>
                                </>} */}

                                {(equipamentType === 'd0effc9e-4b90-4212-b800-4fb17cd5f67a' || equipamentType === 'de4a6821-eb4c-492b-96c1-7ab704f053f6') &&
                                <>
                                    <Label text={t("inputs.resolution.label")} aling="flex-start"/>
                                    <Input 
                                        aling="flex-start"
                                        id='resolution' 
                                        name='resolution' 
                                        type="number" 
                                        placeholder={t("inputs.resolution.placeholder")}
                                        innerRef={ResolutionField}
                                        invalidMessage={t("inputs.resolution.invalid-message")}
                                        validationFunction={(text) => isValidField(text)}
                                        onchange={(text) => ResolutionValue.current = text}> 
                                    </Input>
                                </>}
                            </ContainerColumn>
                        </ContainerRow>
                        <ButtonsContainer>
                            <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={() => Save()}/>
                            <Button text={t("buttons.cancel")} width={'150px'} color={'white-red'} onClick={() => store.dispatch(changeModal(''))}/>
                        </ButtonsContainer>
                    </>
                :<></>}
            </Modal>
            <CustonModal Title={t("modal.update-jsons.title")} Active={activeModal === 'update-jsons'}>
                <RowContainer>
                    <Button width={'fit-content'} text={t("buttons.confirm")} onClick={() => Services.current.refreshAllEquipments()}/>
                    <Button $borderRadius={'10px'} text={t("buttons.cancel")} color={'white-red'} onClick={() => setActiveModal('')}> {t("buttons.cancel")} </Button>
                </RowContainer>
            </CustonModal>
        </>
    )
}

export default ListEquipaments;